import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BikesView } from "../VIEW/BikesView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function BikesPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.BIKES}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <BikesView uid={user.uid} />;
}

export default BikesPage;
